var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-logo"},[_c('img',{staticClass:"logo-img",attrs:{"alt":"","src":`${_vm.baseUrl}img/logo/logo-cyclopic-cities.svg`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }